// extracted by mini-css-extract-plugin
module.exports = {"text":"Lagnateikningar-module--text--pP7M0"};